module.exports = __webpack_public_path__ + "img/send -2.32af686b.webp";